import { render, staticRenderFns } from "./MBTIResult.vue?vue&type=template&id=796828c2&scoped=true"
import script from "./MBTIResult.vue?vue&type=script&lang=js"
export * from "./MBTIResult.vue?vue&type=script&lang=js"
import style0 from "./MBTIResult.vue?vue&type=style&index=0&id=796828c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796828c2",
  null
  
)

export default component.exports